import React, { useState, useEffect } from 'react';

let showToastGlobal = null;

export const useToast = () => {
  return {
    showToast: (message, type = 'success') => {
      console.log('🍞 Toast called:', message, type);
      if (showToastGlobal) {
        showToastGlobal(message, type);
      }
    }
  };
};

export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    showToastGlobal = (message, type) => {
      const id = Date.now();
      setToasts(prev => {
        return [...prev, { id, message, type }];
      });
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 3000);
    };
    return () => {
      console.log('🍞 ToastContainer unmounted');
    };
  }, []);

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`px-4 py-3 rounded shadow-lg text-white text-sm animate-slide-in ${
            toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'
          }`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};
